import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FleetAuth, FleetAuthCheck, FleetAuthField, FleetAuthFields, FleetAuthLetter, FleetAuthorisation } from 'src/app/models/fleetauth';
import { ReportBase64 } from 'src/app/models/reports';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class FleetAuthService {
    apiUrl = 'v1/fleetauth/';

    constructor(private http: HttpClient) { }

    public getFleetAuthData(quoteId: number) {
        return this.http.get<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId, { params: { includeProcessDocument: false } });
    }

    public getProcessDocument(quoteId: number) {
        return this.http.get<ReportBase64>(environment.ApiUrl() + this.apiUrl + quoteId + '/ProcessDocument');
    }

    public saveFleetAuthFields(quoteId: number, body: FleetAuthFields) {
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/fields', body);
    } 

    public resendEmail(quoteId: number, emailAddresses: string) {
        const body = { emailAddresses: emailAddresses };
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/ResendEmail', body);
    }   

    public getField(quoteId: number, fleetAuthFieldValueId: number) {
        return this.http.get<FleetAuthField>(environment.ApiUrl() + this.apiUrl + quoteId + '/field/' + fleetAuthFieldValueId, );
    }

    public submitFleetAuth(quoteId: number) {
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/SubmitAuth', null);
    }

    public submitFleetEAuth(quoteId: number) {
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/SubmitEAuth', null);
    }

    public checkEAuthStatus(quoteId: number) {
        return this.http.get<FleetAuthCheck>(environment.ApiUrl() + this.apiUrl + quoteId + '/CheckEAuth');
    }

    public cancelEAuth(quoteId: number) {
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/CancelEAuth', { fields: [] }, { params: { includeProcessDocument: false } });
    }

    public submitFleetAuthCallCentre(quoteId: number, sfReference: string, fleetAuthForm: FleetAuthorisation) {
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/' + sfReference + '/CallCentreAuthorise', fleetAuthForm);
    }

    public getfleetAuthDataCallCentre(orderId: number, sfReference: string)
    {
      return this.http.get<FleetAuth>( environment.ApiUrl() + this.apiUrl + orderId + "/" + sfReference);
    }

    public uploadAuthLetter(sfRef: string, fleetAuthLetter: FleetAuthLetter) {
        return this.http.post<FleetAuthLetter>(environment.ApiUrl() + this.apiUrl + fleetAuthLetter.quoteId + '/' + sfRef+  '/UploadAuthLetter', fleetAuthLetter);
    }

    public UpdateStateId(quoteId: number, sfRef: string, stateId: number) {
        const body = {quoteId, stateId}
        return this.http.put<string>(environment.ApiUrl() + this.apiUrl + quoteId + '/' + sfRef+  '/UpdateStateId', body);
    }
    public fleetAuthorise(quoteId: number, sfReference: string, body: FleetAuthorisation) {
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/'+ sfReference + '/Authorise', body);
    }

    public updateEmailAddresses(quoteId: number, body: FleetAuth) {
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/UpdateEmailAddresses', body);
    }

    public fleetAuthoriseSalesman(quoteId: number, body: FleetAuthorisation) {
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId +  '/Authorise', body);
    }
    
    public uploadAuthLetterSalesman(fleetAuthLetter: FleetAuthLetter) {
        return this.http.post<FleetAuthLetter>(environment.ApiUrl() + this.apiUrl + fleetAuthLetter.quoteId +  '/UploadAuthLetter', fleetAuthLetter);
    }

    public downloadQuoteDocument(quoteId: number, sfRef: string) {
        return this.http.get<ReportBase64>(environment.ApiUrl() + this.apiUrl + quoteId + '/' + sfRef + '/DownloadQuoteDocument');
    }

    public removeAuthField(quoteId: number, fleetAuthFieldValueId: number){
        return this.http.post<FleetAuth>(environment.ApiUrl() + this.apiUrl + quoteId + '/fields/' + fleetAuthFieldValueId + '/remove', {});
    }
}
